import { PluExportFormat, PluField } from '../types'

export type PluRow = Partial<Record<PluField, string | number | null>>

/**
 * The PLU list file for a label-printing scale, in that model's format (catalog `plu_export`). Variations without a
 * `plu_code` (made offline, not synced yet) are left out (POS.md §18.8).
 */
export const buildPluExport = (rows: PluRow[], format: PluExportFormat) => {
  const cell = (v: unknown, pad?: number) => {
    let s = v === null || v === undefined ? '' : String(v)
    if (format.encoding === 'ascii') s = s.replace(/[^\x20-\x7e]/g, '?')
    if (pad) s = s.padStart(pad, '0')
    return s.includes(format.delimiter) || s.includes('"') ? `"${s.replace(/"/g, '""')}"` : s
  }
  const lines = rows
    .filter((r) => r.plu_code)
    .map((r) => format.columns.map((c) => cell(c.field ? r[c.field] : c.value, c.pad)).join(format.delimiter))
  if (format.header) lines.unshift(format.columns.map((c) => cell(c.title)).join(format.delimiter))
  return { filename: `plu.${format.extension}`, text: lines.join('\r\n') + '\r\n' }
}
